import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from '../../admin/app';
import Modal from '../../common/components/Modal';
export default class LoadingModal extends Modal {
  className() {
    return 'LoadingModal Modal--small';
  }
  title() {
    return app.translator.trans('core.admin.loading.title');
  }
  content() {
    return null;
  }
}
_defineProperty(LoadingModal, "isDismissibleViaCloseButton", false);
_defineProperty(LoadingModal, "isDismissibleViaEscKey", false);
_defineProperty(LoadingModal, "isDismissibleViaBackdropClick", false);
flarum.reg.add('core', 'admin/components/LoadingModal', LoadingModal);